<template>
  <div v-if="has_team_store">
    <div class="match-info-head-wrap">
      <h1 itemprop="headline" class="head-title">{{ generateHeadline() }}</h1>
      <p>{{ generateDesc() }}</p>
    </div>
    <lineup-listing
      v-if="current_match && current_match.show_lineup"
      :togglePlayerPopup="togglePlayerPopup"
    />
    <custom-team-preview
      v-if="custom_image_preview.can_show"
      :image="custom_image_preview.image"
      :closePreview="
        () => {
          custom_image_preview = { can_show: false, image: '' };
        }
      "
    />
    <player-popup
      v-if="playerPopupObj && playerPopupObj.pid"
      :togglePlayerPopup="togglePlayerPopup"
      :player="playerPopupObj"
      :current_match="current_match"
      :isNDTV="false"
    />
  </div>
</template>
<script>
import {
  cssImport,
  getMatch,
  getMatchInfoTitle,
  _lo_canStartPolling,
  _lo_getPollingPriority,
} from "../../../assets/js/common";
import teamStore from "../../../store/modules/matchDetails/teamStore";
import LineupListing from "./LineupListing";
import CustomTeamPreview from "./CustomTeamPreview";

export default {
  props: ["parentRoute"],
  components: {
    LineupListing,
    CustomTeamPreview,
    PlayerPopup: () =>
      import(
        /* webpackChunkName: "player-popup" */ "../../playerPopup/PopupParent"
      ),
  },
  data() {
    return {
      checkMatchUpdatesTimer: null,
      custom_image_preview: {
        can_show: false,
        image: "",
      },
      playerPopupObj: null,
    };
  },
  computed: {
    has_team_store() {
      return !!(this.$store.state && this.$store.state.team_store && this.$store.state.team_store.teams_store_filled);
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    in_match_categories() {
      return this.$store.state.match_detail_store.in_match_categories;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    is_pre_match() {
      let curr_match = this.current_match;
      return !!(curr_match && curr_match.status === 1);
    },
    no_matches_active() {
      return this.$store.state.match_detail_store.no_matches_active;
    },
    translations() {
      return this.$store.state.translations;
    },
    is_custom_client() {
      return this.$store.state.is_custom_client;
    },
    /**shared state end */
    is_polling: {
      get: function () {
        return this.$store.state.team_store.is_polling;
      },
      set: function (val) {
        this.$store.state.team_store.is_polling = val;
      },
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("team_store", teamStore);
    return await this.$store.dispatch("team_store/fetchLineupConfig");
  },
  beforeMount() {
    this.registerModule();
  },
  mounted() {
    let hasStore = this.has_team_store;
    if (!hasStore) {
      cssImport(["/static-assets/css/lineup-v1.css"]);
      this.callApis();
    } else {
      setTimeout(() => {
        // to avoid LCP and LTS issues we call refreshing data after 5 seconds
        this.$store.dispatch("team_store/matchDataUpdatePolling"); // when data comes from serverside then always hit polling api
        this.startMatchPolling();
      }, 5000);
    }
    let location = new URL(window.location.href);
    if (
      location.searchParams.has("ogimg") &&
      location.searchParams.has("strategy") &&
      +location.searchParams.get("strategy") === 0
    ) {
      this.custom_image_preview.can_show = true;
      this.custom_image_preview.image = location.searchParams.get("ogimg");
    }
  },
  methods: {
    registerModule() {
      let hasComponentModule = this.$store.hasModule("team_store");
      if (!hasComponentModule) {
        this.$store.registerModule("team_store", teamStore, {
          preserveState: this.has_team_store,
        });
      }
    },
    callApis() {
      this.componentPromises = this.initApis();
      this.componentPromises.then(() => {
        this.startMatchPolling();
      });
    },
    async initApis() {
      return await this.$store.dispatch("team_store/fetchLineupConfig");
    },
    generateHeadline() {
      return getMatchInfoTitle(
        this.current_match,
        this.translations.lineup_headline
      );
    },
    generateDesc() {
      return getMatchInfoTitle(
        this.current_match,
        this.translations.lineup_headline,
        false,
        false,
        true
      );
    },
    togglePlayerPopup(playerObj) {
      this.playerPopupObj = playerObj;
    },
    startMatchPolling() {
      //poll match
      //if lg = 2 n ls = 1
      //fetch config with buster and update lineup
      if (this.no_matches_active || !(this.current_match && this.current_match.code)) {
        clearInterval(this.checkMatchUpdatesTimer);
        return;
      }
      if (this.is_polling) return;

      if (this.checkMatchUpdatesTimer)
        clearInterval(this.checkMatchUpdatesTimer);

      let canStartPolling = _lo_canStartPolling(this.current_match);
      if (canStartPolling) {
        this.polling_priority = _lo_getPollingPriority(this.current_match);
        this.is_polling = true;
        console.log("current pr", this.polling_priority.ref);

        this.startInterval();
      }
    },
    startInterval() {
      this.checkMatchUpdatesTimer = setInterval(() => {
        if (!_lo_canStartPolling(this.current_match)) {
          this.is_polling = false;
          clearInterval(this.checkMatchUpdatesTimer);
          return;
        }
        console.log("current pr", this.polling_priority.ref);
        let checkPriority = _lo_getPollingPriority(this.current_match);
        console.log("updated pr", checkPriority.ref);

        if (this.polling_priority.ref !== checkPriority.ref) {
          this.is_polling = false;
          return this.startMatchPolling();
        }
        this.can_update = true;
        this.$store.dispatch("team_store/matchDataUpdatePolling");
      }, this.polling_priority.interval);
    },
    // eventChangeHandler() {
    //   this.is_polling = false;
    //   clearInterval(this.checkMatchUpdatesTimer);
    //   this.startMatchPolling();
    //   this.$store.dispatch("team_store/resetLineup");
    //   this.$store.dispatch("team_store/fetchLineupConfig");
    // },
  },
  beforeDestroy() {
    // reset tips data
    this.is_polling = false;
    clearInterval(this.checkMatchUpdatesTimer);
    this.checkMatchUpdatesTimer = null;
    this.$store.dispatch("team_store/resetLineup");
  },
  unmounted() {
    if (this.componentPromises) {
      this.componentPromises.then(() => {
        this.$store.unregisterModule("team_store");
      });
    } else {
      this.$store.unregisterModule("team_store");
    }
  },
};
</script>
